// @flow

import logStats from 'app/common/lib/logStats';

const MAX_SCRIPT_READY_CHECK_TIMES = 20;
const INTERVAL_IN_MILL_SECS = 100;
const SAMPLE_RATE_ONE_HUNDREDTH = 0.01;
export const SCRIPT_TYPE = Object.freeze({
  OTHER: 0,
  FACEBOOK: 1,
  GPLUS_ONE: 2,
});

export default function loadScript(path: string): Promise<any> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${path}"]`)) {
      // don't load scripts that have already been loaded
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = path;
    script.async = true;
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}

export function loadScriptWithWait(
  path: string,
  targetType: number = SCRIPT_TYPE.OTHER,
  isDesktop: boolean = false,
): Promise<any> {
  const platform = isDesktop ? 'web' : 'mweb';
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${path}"]`)) {
      // don't load scripts that have already been loaded
      let cnt = 0;
      if (targetType === SCRIPT_TYPE.GPLUS_ONE) {
        if (!!window.gapi) {
          resolve();
        } else {
          const intervalId = setInterval(() => {
            // the script is loaded async, so the exist of the tag doesn't guarantee the object is ready in javascript.
            // wait here until the target is available or exceed the limit
            if (!!window.gapi || cnt === MAX_SCRIPT_READY_CHECK_TIMES) {
              clearInterval(intervalId);
              resolve();
            } else {
              cnt += 1;
              logStats.increment(
                `${platform}.loadScript.gplus_one.tries_${cnt}`,
                SAMPLE_RATE_ONE_HUNDREDTH,
              );
            }
          }, INTERVAL_IN_MILL_SECS);
        }
      } else if (targetType === SCRIPT_TYPE.FACEBOOK) {
        if (!!window.FB) {
          resolve();
        } else {
          const intervalId = setInterval(() => {
            // the script is loaded async, so the exist of the tag doesn't guarantee the object is ready in javascript.
            // wait here until the target is available or exceed the limit
            if (!!window.FB || cnt === MAX_SCRIPT_READY_CHECK_TIMES) {
              clearInterval(intervalId);
              resolve();
            } else {
              cnt += 1;
              logStats.increment(
                `${platform}.loadScript.facebook.tries_${cnt}`,
                SAMPLE_RATE_ONE_HUNDREDTH,
              );
            }
          }, INTERVAL_IN_MILL_SECS);
        }
      } else {
        resolve();
      }
    } else {
      const script = document.createElement('script');
      script.src = path;
      script.async = true;
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  });
}
